export default __webpack_public_path__ + "static/media/download.09468964.svg";